import {Component, inject, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {IdsEditorComponent} from '../../checks/bimCheck/components/ids/ids-editor/ids-editor.component';
import {StateConfigService} from '../../../services/state/state-config.service';
import {DiscardOutcome} from '../../../guards/unsaved-changes.guard';

@Component({
  selector: 'app-ids-rule-management-editor',
  standalone: true,
  imports: [IdsEditorComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <app-ids-editor [showBackButton]="true" [backRoute]="backRoute" [readOnly]="readOnly"
                    [adminGlobal]="adminGlobal" [ruleTestEnabled]="!adminGlobal"></app-ids-editor>`,
})
export class IdsRuleManagementEditorComponent implements OnInit {
  private stateConfigService = inject(StateConfigService);
  private route = inject(ActivatedRoute);
  /** Der `UnsavedChangesGuard` bekommt diese (geroutete) Komponente, nicht den eingebetteten Editor. */
  @ViewChild(IdsEditorComponent) private editor?: IdsEditorComponent;
  backRoute: any[] = [];
  /** View-only Modus (bereitgestelltes Regelwerk ohne Bearbeitungsrecht). */
  readOnly = false;
  /** Admin-Modus: globales Regelwerk ohne Projektkontext. */
  adminGlobal = false;

  /** Für den `UnsavedChangesGuard`: ungespeicherte Änderungen im eingebetteten Editor. */
  get isDirty(): boolean {
    return this.editor?.isDirty ?? false;
  }

  /** Für den `UnsavedChangesGuard`: „Verwerfen" im Dialog – verwirft auch einen offenen chatBIC-Vorschlag. */
  discardChanges(): DiscardOutcome {
    return this.editor?.discardChanges() ?? 'discarded';
  }

  ngOnInit(): void {
    this.adminGlobal = this.route.snapshot.data['adminGlobal'] === true;
    const projectId = this.stateConfigService.selectedProject?.id;
    this.backRoute = this.adminGlobal ? ['admin', 'my-checks'] : ['projects', projectId, 'my-checks'];
    this.readOnly = this.route.snapshot.queryParamMap.get('readOnly') === 'true';

    // Pass the ruleId via sessionStorage so the IDS editor picks it up on init.
    // 'new' means a fresh rule – don't set sessionStorage.
    const ruleId = this.route.snapshot.paramMap.get('rulesetId');
    if (ruleId && ruleId !== 'new') {
      sessionStorage.setItem('ids-edit-ruleId', ruleId);
    }
  }
}
